import PortalIdParser from 'PortalIdParser';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { H2 } from 'foundations-components/transitional/components/H2';
import DataSyncAuthForm from 'ui-universal-auth/DataSyncAuthForm';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { getPageTitleForApp, getDataSyncUrlSearchParamsForApp, getAppIdForDataSyncApp } from '../../utils/connectAppUtils';
import { redirectTo } from '../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ConnectAppModal = ({
  app,
  rootNode,
  onClose = () => {},
  onCloseComplete,
  onCancel = () => {},
  onOpen = () => {},
  onSyncDoThisLaterClick = () => {},
  onSyncBeginSetupClick = () => {},
  onConnectionComplete = () => {}
}) => {
  const appId = getAppIdForDataSyncApp(app);
  const portalId = PortalIdParser.get();
  // 'Outlook or Exchange' becomes 'outlook-or-exchange'
  const normalizedAppName = app.toLowerCase().replace(/ /g, '-');
  const redirectToDataSync = searchParams => event => {
    event.preventDefault();
    const url = new URL(event.currentTarget.href);
    const searchParamsToAppend = Array.isArray(searchParams) ? searchParams : [searchParams];
    for (const {
      param,
      value
    } of searchParamsToAppend) {
      url.searchParams.append(param, value);
    }
    redirectTo(url.toString());
  };
  return /*#__PURE__*/_jsxs(Modal, {
    "data-test-id": `connect-${normalizedAppName}-modal`,
    onOpenComplete: () => onOpen(app),
    onCloseComplete: onCloseComplete,
    rootNode: rootNode,
    use: "default",
    width: 780,
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(H2, {
        children: getPageTitleForApp(app)
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: () => onClose(app)
      })]
    }), /*#__PURE__*/_jsxs(DialogBody, {
      paddingBlockEnd: "600",
      children: [/*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "growthDataModal.connectApp.header.helperTextNew_jsx",
        elements: {
          p: 'p'
        }
      }), portalId && appId && /*#__PURE__*/_jsx(DataSyncAuthForm, {
        portalId: portalId,
        appId: appId,
        onComplete: () => onConnectionComplete(app),
        onSetupSyncClick: () => {
          onSyncBeginSetupClick(app);
          return redirectToDataSync([...getDataSyncUrlSearchParamsForApp(app), {
            param: 'via',
            value: 'data-management'
          }, {
            param: 'import',
            value: ''
          }]);
        },
        onDoThisLaterClick: () => {
          onSyncDoThisLaterClick(app);
          return redirectToDataSync({
            param: 'tourId',
            value: 'skip-data-sync-setup'
          });
        },
        onCancel: () => onCancel(app)
      })]
    })]
  });
};
export default ConnectAppModal;